<template>
<div class="df">

<div class="pas">
<a-button type="primary" @click="$router.back()">返回</a-button>
</div>

<div class="title" style="marginTop:80px">基本情况</div>
<table style="word-break:break-all; word-wrap:break-all;" class="tab2" width="800" border="1" cellspacing="0">




      <tr>
        <td>姓名</td>
        <td>{{baseInfo.a0101}}</td>
        <td>性别</td>
        <td>{{baseInfo.a0104}}</td>
        <td>民族</td>
        <td>{{baseInfo.a0117}}</td>
        <td class="limit" rowspan="3"><img :src="imgUrl" alt="暂无"></td>
      </tr>
      <tr>
        <td>政治面貌</td>
        <td>{{baseInfo.a0141}}</td>
        <td>出生日期</td>
        <td colspan="3">{{baseInfo.a0107}}</td>
      </tr>
      <tr>
        <td>身高</td>
        <td colspan="3">{{baseInfo.a0108}}cm</td>
        <td>体重</td>
        <td>{{baseInfo.a01101}}kg</td>
      </tr>
      <tr>
        <td>婚姻状况</td>
        <td colspan="2">{{baseInfo.a0131}}</td>
        <td colspan="2">身份证号</td>
        <td colspan="2">{{baseInfo.a0184}}</td>
      </tr>
      <tr>
        <td colspan="2">籍贯</td>
        <td>{{baseInfo.a0111a}}</td>
        <td colspan="2">健康状况</td>
        <td colspan="2">{{baseInfo.a0127a}}</td>
      </tr>
      <tr>
        <td colspan="2">特长</td>
        <td colspan="5">{{baseInfo.a01102}}</td>
      </tr>
      <tr>
        <td colspan="2">兴趣爱好</td>
        <td colspan="5">{{baseInfo.a01103}}</td>
      </tr>
      <tr>
        <td colspan="2">移动电话</td>
        <td colspan="2">{{baseInfo.a01104}}</td>
        <td colspan="2">住址电话</td>
        <td>{{baseInfo.a01105}}</td>
      </tr>
      <tr>
        <td colspan="2">电子邮箱</td>
        <td colspan="2">{{baseInfo.a01106}}</td>
        <td colspan="2">邮政编码</td>
        <td>{{baseInfo.a01108}}</td>
      </tr>
      <tr>
        <td colspan="2">通信地址</td>
        <td colspan="5">{{baseInfo.a01107}}</td>
      </tr>
      <tr>
        <td colspan="2">现居住地址</td>
        <td colspan="5">{{baseInfo.a0110}}</td>
      </tr>



</table>

<div class="title">学习经历</div>
<table style="word-break:break-all; word-wrap:break-all;" class="tab" width="800" border="1" cellspacing="0">
  <thead>
    <th>起止时间</th>
    <th>学历</th>
    <th>学位</th>
    <th>院校</th>
    <th>学院</th>
    <th>所有专业</th>
    <th>教育类型</th>
    <th>学制</th>
  </thead>
  <tr v-for="(item,i) in studyInfo" :key="i">
    <td>{{item.A0801}}~{{item.A0802}}</td>
    <td>{{item.A0803}}</td>
    <td>{{item.A0804}}</td>
    <td>{{item.A0805}}</td>
    <td>{{item.A0806}}</td>
    <td>{{item.A0807}}</td>
    <td>{{item.A0813}}</td>
    <td>{{item.A0814}}</td>
  </tr>
</table>

<div class="title">工作经历</div>
<table style="word-break:break-all; word-wrap:break-all;" class="tab" width="800" border="1" cellspacing="0">
  <thead>
    <th>起止时间</th>
    <th>所在单位</th>
    <th>从事工作或担任职务</th>
  </thead>
  <tr v-for="(item,i) in jobInfo" :key="i">
    <td>{{item.A4801}}~{{item.A4802}}</td>
    <td>{{item.A4803}}</td>
    <td>{{item.A4805}}</td>
  </tr>
</table>

<div class="title">家庭成员</div>
<table style="word-break:break-all; word-wrap:break-all;" class="tab" width="800" border="1" cellspacing="0">
  <thead>
    <th>姓名</th>
    <th>与本人关系</th>
    <th>民族</th>
    <th>政治面貌</th>
    <th>出生日期</th>
    <th>联系电话</th>
    <th>工作单位及职务</th>
  </thead>
  <tr v-for="(item,i) in FmInfo" :key="i">
    <td>{{item.A15NAME}}</td>
    <td>{{item.YBRGX}}</td>
    <td>{{item.A15MZ}}</td>
    <td>{{item.A15ZZMM}}</td>
    <td>{{item.CSRQ}}</td>
    <td>{{item.LXDH}}</td>
    <td>{{item.GZDWJZW}}</td>
  </tr>
</table>

<div class="title">应届毕业生信息</div>
<table style="word-break:break-all; word-wrap:break-all;"e class="tab2" width="800" border="1" cellspacing="0">


  <tr>
    <td>生源地</td>
    <td colspan="2">{{studentInfo.a0186}}</td>
    <td>学校所在城市</td>
    <td colspan="2">{{studentInfo.a01110}}</td>
  </tr>
  <tr>
    <td>英语等级或六级成绩</td>
    <td colspan="2">{{studentInfo.a0193}}</td>
    <td>是否委培生</td>
    <td colspan="2">{{studentInfo.a01112}}</td>
  </tr>
  <tr>
    <td>是否定向生</td>
    <td colspan="2">{{studentInfo.a01113}}</td>
    <td>是否计划外招生</td>
    <td colspan="2">{{studentInfo.a01114}}</td>
  </tr>
  <tr>
    <td>担任学生干部情况</td>
    <td colspan="5">{{studentInfo.a0191}}</td>
  </tr>
  <tr>
    <td>学校通讯地址</td>
    <td colspan="5">{{studentInfo.a0195}}</td>
  </tr>
  <tr>
    <td>学校邮政编码</td>
    <td colspan="5">{{studentInfo.a01117}}</td>
  </tr>

  <tr>
    <td>院系学生工作主管老师</td>
    <td colspan="2">{{studentInfo.a01118}}</td>
    <td>院系学生工作主管老师电话</td>
    <td colspan="2">{{studentInfo.a01119}}</td>
  </tr>
  <tr>
    <td colspan="1">奖惩情况及学术科研成果</td>
    <td colspan="5">{{studentInfo.a01115}}</td>
  </tr>




</table>

<div class="title">社会招聘信息</div>
<table style="word-break:break-all; word-wrap:break-all;" width="800" border="1" cellspacing="0">


  <tr>
    <td>户籍所在地</td>
    <td colspan="2">{{SociolInfo.a01120}}</td>
    <td>档案所在地</td>
    <td colspan="2">{{SociolInfo.zdyxa0105}}</td>
  </tr>
  <tr>
    <td>首次参加工作时间</td>
    <td colspan="2">{{SociolInfo.zdyxa123}}</td>
    <td>现工作状态</td>
    <td colspan="2">{{SociolInfo.a01121}}</td>
  </tr>
  <tr>
    <td>现工作单位</td>
    <td colspan="2">{{SociolInfo.a01122}}</td>
    <td>入职现工作单位时间</td>
    <td colspan="2">{{SociolInfo.a01123}}</td>
  </tr>
  <tr>
    <td>现担任职务</td>
    <td colspan="2">{{SociolInfo.a01124}}</td>
    <td>任职时间</td>
    <td colspan="2">{{SociolInfo.a0113}}</td>
  </tr>
  <tr>
    <td>工作技能</td>
    <td colspan="5">{{SociolInfo.a01125}}</td>
  </tr>
  <tr>
    <td>奖惩情况</td>
    <td colspan="5">{{SociolInfo.a01126}}</td>
  </tr>





</table>

</div>

</template>

<script>
var configLink = require('../../../../config/index')

export default {
  data(){
    return{
      // 基本情况
      baseInfo:{
        a0101:'',
        a0104:'',
        a0117:'',
        a0141:'',
        a0107:'',
        a0108:'',
        a01101:'',
        a0131:'',
        a0184:'',
        a0111a:'',
        a0127a:'',
        a01102:'',
        a01103:'',
        a01104:'',
        a01105:'',
        a01106:'',
        a01107:'',
        a01108:'',
        a0110:''
      },
      // 学习经历
      studyInfo:[],
      // 工作经历
      jobInfo:[],
      // 家 庭 成 员
      FmInfo:[],
      // 应届毕业生信息
      studentInfo:{},
      // 社会招聘信息
      SociolInfo:{},

      //照片
      imgUrl:''
    }
  },

  created(){
    console.log(1);
    console.log(this.$route.query.data.data);
    var datas1=this.$route.query.data.data.A01BaseList[0]
    var datas2=this.$route.query.data.data.Bjja08BaseList
    var datas3=this.$route.query.data.data.A48BaseList
    var datas4=this.$route.query.data.data.A15BaseList

    const fidId=this.$route.query.fidId
    console.log(configLink.dev.proxyTable['/dev-api'].target)
    this.imgUrl='/dev-api/platservice/fileupload/previewImage?fid='+ fidId + '&BDSOFT-TOKEN=' + sessionStorage.getItem('BDSOFT-TOKEN')
    // 基本情况
    this.baseInfo.a0101=datas1.PNAME
    this.baseInfo.a0104=datas1.SEX
    this.baseInfo.a0117=datas1.MZ
    this.baseInfo.a0141=datas1.ZZMM
    this.baseInfo.a0107=datas1.CSRQ
    this.baseInfo.a0108=datas1.SG
    this.baseInfo.a01101=datas1.TZ
    this.baseInfo.a0131=datas1.HYZK
    this.baseInfo.a0184=datas1.SFZH
    this.baseInfo.a0111a=datas1.JG
    this.baseInfo.a0127a=datas1.JKZK
    this.baseInfo.a01102=datas1.TC
    this.baseInfo.a01103=datas1.XQAH
    this.baseInfo.a01104=datas1.YDDH
    this.baseInfo.a01105=datas1.ZZDH
    this.baseInfo.a01106=datas1.DZYX
    this.baseInfo.a01108=datas1.YZBM
    this.baseInfo.a01107=datas1.TXDZ
    this.baseInfo.a0110=datas1.XZZ

    // // 应届毕业生信息
    this.studentInfo.a0186=datas1.SYD
    this.studentInfo.a01110=datas1.XXSZD
    this.studentInfo.a0193=datas1.YULJCJ
    this.studentInfo.a01112=datas1.SFWPS
    this.studentInfo.a01113=datas1.SFDXS
    this.studentInfo.a01114=datas1.SFJHWZS
    this.studentInfo.a0191=datas1.XSGB
    this.studentInfo.a0195=datas1.XXTXDZ
    this.studentInfo.a01117=datas1.XXYB
    this.studentInfo.a01118=datas1.ZGLS
    this.studentInfo.a01119=datas1.ZGLSDH
    this.studentInfo.a01115=datas1.JCQKJKYCG



    // // 社会招聘信息
    this.SociolInfo.a01120=datas1.HKSZD
    this.SociolInfo.zdyxa0105=datas1.DASZD
    this.SociolInfo.zdyxa123=datas1.SCCJGZSJ
    this.SociolInfo.a01121=datas1.XGZZT
    this.SociolInfo.a01122=datas1.XGZDW
    this.SociolInfo.a01123=datas1.DWSJ
    this.SociolInfo.a01124=datas1.XRZW
    this.SociolInfo.a0113=datas1.RZSJ
    this.SociolInfo.a01125=datas1.SZGZJN
    this.SociolInfo.a01126=datas1.SZJCQK


    // //学习经历
    this.studyInfo=datas2

    // //工作经历
    this.jobInfo=datas3

    // //家庭成员
    this.FmInfo=datas4

  }
}
</script>

<style scoped>
  table{
    font-size: 24px;
    text-align: center;
    margin: 0 auto;
    min-height: 600px;
    width: 1000px;
  }
  .tab{
    min-height: 200px;
  }
  .tab2{
    min-height: 800px;
  }
  .df{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .title{
    font-size: 20px;
    font-weight: bold;
    color: #000;
    margin-top: 30px;
  }
  td{
    min-width: 100px;
    max-width: 400px;
  }
  .pas{
    position: absolute;
    right: 40px;
    top: 10px;
  }
  .limit{
    max-width: 142px;
    max-height: 218px;
  }
  .limit img{
    max-width: 142px;
    max-height: 218px;
  }
  /deep/ .pas .ant-btn{
    width: 120px;
    height: 50px;
  }
  </style>





// WEBPACK FOOTER //
// src/views/wdjl/pages/yl.vue